import React, { createContext, useState } from 'react';
import type { ProductVariant } from '../redux/productSlice';
const ProductContext = createContext<ProductContextType>({
  formData: {
    productname: '',
    category: '',
    subcategory: '',
    unitofmass: '',
    buyingprice: '',
    sellingprice: '',
    quantity: '',
    pid: '',
    mass: '',
    size: '',
    model: '',
    msl: '',
    wastedquantity: '',
    barcode: '',
    bp_product_image: '',
    bp_product_image_uri: '',
    hasVariants: false,
    variantAttributes: [],
    variants: [],
  },
  setFormData: () => {},
});

export interface ProductContextType {
  formData: {
    productname: string;
    category: string;
    subcategory: string;
    unitofmass: string;
    buyingprice: string;
    sellingprice: string;
    quantity: string;
    pid: string;
    mass: string;
    size: string;
    model: string;
    msl: string;
    wastedquantity: string;
    barcode: string;
    bp_product_image: string;
    bp_product_image_uri: string;
    hasVariants: boolean;
    variantAttributes: string[];
    variants: ProductVariant[];
  };
  setFormData: (formData: ProductContextType['formData']) => void;
}

export const ProductContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [formData, setFormData] = useState<ProductContextType['formData']>({
    productname: '',
    category: '',
    subcategory: '',
    unitofmass: '',
    buyingprice: '',
    sellingprice: '',
    quantity: '',
    pid: '',
    mass: '',
    size: '',
    model: '',
    msl: '',
    wastedquantity: '',
    barcode: '',
    bp_product_image: '',
    bp_product_image_uri: '',
    hasVariants: false,
    variantAttributes: [],
    variants: [],
  });

  return (
    <ProductContext.Provider
      value={{
        formData,
        setFormData,
      }}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductContext;
